<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Functions</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Functions</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="ptb--100 ">
  <div class="container">
    <div class="row justify-content-center gx-4">
      <div class="col-md-12">
        <div class="sec-title">
          <h2 class="fs-3"><span>IQAC Functions - As per UGC Guidelines</span></h2>
        </div>
        <ul class="list-before">
          <li>Development and application of quality benchmarks/parameters for the various academic and administrative
            activities of the Colleges;</li>
          <li>Facilitating the creation of a learner-centric environment conducive for quality education and faculty
            maturation to adopt the required knowledge and technology for participatory teaching and learning process.
          </li>
          <li>Arrangement for feedback responses from students, parents and other stakeholders on quality-related
            institutional processes</li>
          <li>Dissemination of information on the various quality parameters of higher education.</li>
          <li>Organization of inter and intra institutional workshops, seminars on quality related themes and promotion
            of quality circles;</li>
          <li>Documentation of the various programmes/activities of the College, leading to quality improvement</li>
        </ul>

        <div class="sec-title">
          <h2 class="fs-3"><span>IQAC - Institutional Functioning</span></h2>
        </div>
        <ul class="list-before">
          <li>The institution has active Quality Advisory Cell (QAC) and Internal Quality Assurance Cell (IQAC) to frame
            the policy for the academic and administrative growth of the institution.</li>
          <li> IQAC is playing a major role in designing and maintaining quality assurance within academic systems.</li>
          <li>IQAC monitors the proper implementation and analysis of overall academic and administrative performances
            of the college activities.</li>
          <li>The cell supports the teaching and learning goals articulated in the institution’s strategic plan.</li>
          <li>As the institution has grown in size and stature, it has evolved certain quality assurance measures
            keeping in mind the academic and administrative requirements.</li>
          <li>In this regard, a manual on teaching and working has been prepared by Professor-in-charge, IQAC. Some of
            the measures are –</li>
          <li>IQAC ensures maximum utilization of infrastructural facilities and the available ICT resources.</li>
          <li>On the basis of academic audit, a comprehensive review of student’s performance is made by IQAC.</li>
          <li> IQAC ensures the proper implementation of academic calendar.</li>
          <li>Regular meeting of IQAC and QAC are conducted to discuss various measures related to quality enhancement
            in which the recommendations made by Planning and Evaluation Board, Board Of Studies, Academic Council,
            Governing Body are discussed and analyzed for further improvement.</li>
          <li>As per the suggestion of IQAC, a feedback analysis committee is formed to review the online and offline
            feedback received from the students.</li>
          <li>Appraisal report of teaching / and non- teaching staff is received in the form of CR and after evaluation
            by the Head of the Institution is forwarded to the higher authorities.</li>
          <li>Attendance registers and daily teaching diaries are duly maintained and checked.</li>
          <li>IQAC reviews the feedback received from the parent- teacher meetings</li>
          <li>Introduction of new Courses including Postgraduate and Add-on Courses.</li>
          <li>Introduction of UGC Community college Scheme.</li>
          <li>Automation of Library and its facilities.</li>
          <li>Strengthening of Library.</li>
          <li>Improvement in students supports systems.</li>
          <li>Organizing seminars, conferences and workshops at different levels.</li>
          <li>Extension and upgradation of Classrooms and Laboratories.</li>
          <li>Inculcate ICT based Teaching-learning process</li>
          <li>IQAC has played an important role to implement NAAC Peer Team recommendations</li>
          <li>The IQAC monitors the well-being of the college in all respects.</li>
        </ul>
      </div>
    </div>
  </div>
</section>
